import { render } from "./SaleMabChart.vue?vue&type=template&id=05ff249c"
import script from "./SaleMabChart.vue?vue&type=script&lang=js"
export * from "./SaleMabChart.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Proj\\Apps\\tabarok_management\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__